import { useTheme } from '@mui/material/styles';
const RootOrganizationIcon = () => {
    const theme = useTheme();
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-registered"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" /><path d="M10 15v-6h2a2 2 0 1 1 0 4h-2" /><path d="M14 15l-2 -2" /></svg>
    )
}


export default RootOrganizationIcon